import styled from 'styled-components'

import { media, mediaMax } from '../../../styles/media'

import PlaceholderCard from '../../cards/PlaceholderCard'
import { Content } from '../../cards/shared/styled'
import { Grid, GridItem } from '../ItemGrid'

const filterBarHeight = '80px'
const FilterBar = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  padding: 0 22px;
  width: 100%;
  height: ${filterBarHeight};
  background-color: white;
  border-bottom: 1px solid;
  border-top: 1px solid;
  border-color: #e5e6e4;
  z-index: 1;
`

const Wrapper = styled.div`
  height: 100vh;
  overflow: hidden;

  ${mediaMax.xl`
    ${FilterBar} {
      display: none;
    }
  `}
`

const ContentWrapper = styled.div`
  display: flex;
  position: relative;
`

/*
  The loading component cannot decide between "mobile" and "desktop" layouts in JS -- it must instead accommodate
  the shape of both within a single wrapper via styled-components' css functions.

  This is because it gets server-side rendered, at which point it has no knowledge yet of whether it's going to be
  in "mobile" or "desktop" view, in the JS context. Our JS will only know once the contentful page mounts on the
  client (search, bucket list, itinerary search, etc.).

  But styled-components do support server-sider rendering and do have media queries avaiable in that context. This is
  why we can use css functions to switch width of the grid items within a single parent, but cannot decide via JS which
  parent to render as the wrapper around those grid items like we do for the contentful pages.
*/
const ResultsWrapper = styled.div`
  padding: 24px 0;
  width: 100%;

  ${media.xl`
    width: calc(100% / 1.61803398875);
    padding: 24px 16px;
  `}

  ${Grid} {
    ${media.sm`
      margin: 0 8px;

      ${Content} {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
    `}

    ${GridItem} {
      width: 100%;

      ${media.sm`
        width: 50%;
        padding: 0 8px;
      `}

      ${media.lg`
        width: 33.333%;
      `}

      ${media.xl`
        width: 50%;
      `}

      ${media.xxxl`
        width: 33.333%;
      `}

      ${media.xwide`
        width: 25%;
      `}
    }
  }
`

const MapWrapper = styled.div`
  flex: 1;
  height: 100vh;
  background-color: #e1dfdb;

  ${mediaMax.xl`
    display: none;
  `}
`

type LoadingViewProps = {
  noFilters?: boolean
}

const LoadingView = ({ noFilters }: LoadingViewProps) => (
  <Wrapper>
    {!noFilters && <FilterBar />}
    <ContentWrapper>
      <ResultsWrapper>
        <Grid>
          {[...Array(12)].map((e, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <GridItem key={i}>
              <PlaceholderCard />
            </GridItem>
          ))}
        </Grid>
      </ResultsWrapper>

      <MapWrapper />
    </ContentWrapper>
  </Wrapper>
)

export default LoadingView
